import ApiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  list(params) {
    return ApiCtrl.get('/user-actions', { params });
  },

  show(userId, params = {}) {
    return ApiCtrl.get(`/user-actions/${userId}`, { params });
  },

  send(userId, action) {
    return ApiCtrl.post(`/user-actions/${userId}/send/${action}`, {});
  },

  markAsSent(userId, action) {
    return ApiCtrl.post(`/user-actions/${userId}/mark-as-sent/${action}`, {});
  },
};
